import { LazyImport, LazyModule } from 'owa-bundling';

export type { default as CalendarSearchResultItem } from './schema/CalendarSearchResultItem';
export type { default as CalendarSearchResultsStore } from './schema/CalendarSearchResultsStore';
export type { default as InstrumentationContext } from './schema/InstrumentationContext';
export { CalendarSearchListViewState } from './schema/CalendarSearchListViewState';
export { default as getStore } from './store';

const lazyModule = new LazyModule(
    () => import(/* webpackChunkName: "SearchResults" */ './lazyIndex')
);

// Lazy-load actions
export let lazyInitSearchResults = new LazyImport(lazyModule, m => m.initSearchResults);
export let lazySetCalendarSearchResults = new LazyImport(
    lazyModule,
    m => m.setCalendarSearchResults
);
export let lazySetSearchMode = new LazyImport(lazyModule, m => m.setSearchMode);
